import React,{useEffect} from 'react'
import { fetchCollectionsStart } from '../../redux/shop/shop.actions'
import {Route } from 'react-router-dom'
import CollectionsOverviewContainer from '../../components/collections-overview/collection-overview.container'
import {connect} from 'react-redux'
import CollectionsPageContainer from '../collection/collection.container'
import Directory from '../../components/directory/directory2.component'
const ShopPage = ({match,fetchCollectionsStart}) => {

    useEffect(()=>{
        fetchCollectionsStart();
    },[fetchCollectionsStart])
    const sections = [
        {
            id: 1,
            title: 'KFC',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FKFC.jpg?alt=media&token=085b4a7a-e890-4515-a042-ad658a4db162',
            routeName: 'shop/kfc',
        },
        {
            id: 2,
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Ffakh.png?alt=media&token=f1e669d5-5355-413a-a56f-09314e66f575',
            title: 'Fakruddin Biryani',
            routeName: 'shop/fakruddin%20biryani',
        },
        {
            id: 3,
            title: 'Pizza Hut',
            routeName: 'shop/pizza%20hut', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fpizza.jpg?alt=media&token=42b57db7-d02c-42b0-ae82-12c9d4977ec3',
        },
        {
            id: 4,
            title: 'Burger King',
            routeName: 'shop/burger%20king', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fburger.jpg?alt=media&token=1db8ce38-0af4-4525-8b69-fbde1fb2e15b',
            linkUrl: 'shop/hats'
        },
        {
            id: 5,
            title: 'Pizza Inn',
            routeName: 'shop/pizza%20inn', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fpizzainn.jpg?alt=media&token=fa0d99ff-72fc-4dfd-9374-15819a735836',
            linkUrl: 'shop/hats'
        },
        {
            id: 6,
            title: 'Shawarma House',
            routeName: 'shop/shawarma%20house', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fshwarmahouse.jpg?alt=media&token=e00c92a7-2e47-498b-bc91-973b2f7f9343',
            linkUrl: 'shop/hats'
        },
        {
            id: 7,
            title: 'Lake Terrace',
            routeName: 'shop/lake%20terrace', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Flaketerrace.png?alt=media&token=3f24a0e1-630a-42f9-8e5b-dd30554e9887',
            linkUrl: 'shop/hats'
        },
        {
            id: 8,
            title: 'La Bamba',
            routeName: 'shop/la%20bamba', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Flabamba.jpg?alt=media&token=d310c553-00b6-45d4-8d77-51dc905fa889',
            linkUrl: 'shop/hats'
        },
        {
            id: 9,
            title: 'California Fried Chicken',
            routeName: 'shop/california%20fried%20chicken', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fcalifornia%20fried%20chicken.jpg?alt=media&token=67400666-41df-43cb-8b20-344ce8dbadf0',
            linkUrl: 'shop/hats'
        },
        {
            id: 10,
            title: 'Pizza End',
            routeName: 'shop/pizza%20end', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fpizzaend.jpg?alt=media&token=4fadf5ab-037e-4dc0-9cac-a504f789f5c2',
            linkUrl: 'shop/hats'
        },
        {
            id: 11,
            title: 'Kabab Factory',
            routeName: 'shop/kabab%20factory', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FKabab-Factory.jpg?alt=media&token=441d93a8-bb2d-4d32-b045-374d9e8c9cf8',
            linkUrl: 'shop/hats'
        },
        {
            id: 12,
            title: 'Sea Shell',
            routeName: 'shop/sea%20shell', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FSea-Shell.jpg?alt=media&token=b9b384ae-50fd-4227-9a86-cc4c6a6a07fa',
            linkUrl: 'shop/hats'
        },
        {
            id: 14,
            title: 'Hakka',
            routeName: 'shop/hakka', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fhakka.jpg?alt=media&token=5638eb8f-474f-4859-8c20-243c17568b45',
            linkUrl: 'shop/hats'
        },
        {
            id: 15,
            title: 'Chiling Thai Chinese & Indian Restaurant',
            routeName: 'shop/chiling%20thai,%20chinese%20&%20indian%20restaurant', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fchillingthai.jpg?alt=media&token=d6a87ded-525f-43a3-8d60-02eb0366bd0d',
            linkUrl: 'shop/hats'
        },
        {
            id: 16,
            title: 'Pizza Margherita',
            routeName: 'shop/pizza%20margherita', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fpizza%20margheri.jpg?alt=media&token=1621db73-ffde-4f7a-a32e-f6342ca551b1',
            linkUrl: 'shop/hats'
        },
        {
            id: 17,
            title: 'Khazana',
            routeName: 'shop/khazana',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fkhazana.jpg?alt=media&token=a8647b30-0496-4573-9a7e-df6efdd90c4c',
            linkUrl: 'shop/hats'
        },
        {
            id: 18,
            title: 'Mainland China',
            routeName: 'shop/mainland%20china', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fmainland%20china.jpg?alt=media&token=7e02f8a7-444d-47af-ba15-cd1afa35c08f',
            linkUrl: 'shop/hats'
        },
        {
            id: 19,
            title: 'Jollichickn',
            routeName: 'shop/jollichickn', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fjollichickin.jpg?alt=media&token=624a6f1b-1f1c-4798-a13e-a3143c76598f',
            linkUrl: 'shop/hats'
        },
        {
            id: 20,
            title: 'Johnny Rockets',
            routeName: 'shop/johnny%20rockets', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fjohny%20rockets.jpg?alt=media&token=4fa5cadc-616e-458b-aa9b-848510beee97',
            linkUrl: 'shop/hats'
        },
        {
            id: 21,
            title: 'Kacchi Vai',
            routeName: 'shop/kacchi%20vai', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FKacchi-Vai.jpg?alt=media&token=ba5b65f9-6bcf-491b-9b17-5391e8dd1431',
            linkUrl: 'shop/hats'
        },
        {
            id: 22,
            title: 'Star Hotel & Restaurant',
            routeName: 'shop/star%20hotel%20&%20restaurant', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/no-image-1.jpg?alt=media&token=94ff0fc7-3f48-4beb-b710-1640696fcbb1',
            linkUrl: 'shop/hats'
        },
        {
            id: 23,
            title: 'Fakruddin Lunch & Dinner',
            routeName: 'shop/fakruddin%20lunch%20&%20dinner', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FAPPLE-Sim-Supported-Smart-Watch-5afab10727f52.png?alt=media&token=9382cb66-06f6-44cd-b98a-be783aad81a1',
            linkUrl: 'shop/hats'
        },
        {
            id: 24,
            title: 'Sultan s Dine',
            routeName: 'shop/sultan%20s%20dine',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FSultan-Dine%20(1).jpg?alt=media&token=d76aedb6-da95-4760-86eb-ba913aef1238',
            linkUrl: 'shop/hats'
        },
        {
            id: 25,
            title: 'Hakka Dhaka',
            routeName: 'shop/hakka%20dhaka', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2Fhakka.jpg?alt=media&token=5638eb8f-474f-4859-8c20-243c17568b45',
            linkUrl: 'shop/hats'
        },
        {
            id: 26,
            title: 'Nandos',
            routeName: 'shop/nandos', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FNandos.png?alt=media&token=d348b65f-3e33-47f8-b299-09649f4eb464',
            linkUrl: 'shop/hats'
        },
        {
            id: 27,
            title: 'Takeout Banani',
            routeName: 'shop/takeout%20banani', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FTakeout-Banani.jpg?alt=media&token=e8b03ca8-75f3-438a-bffb-fa2770f5eea5',
            linkUrl: 'shop/hats'
        },
        {
            id: 28,
            title: 'Platter',
            routeName: 'shop/platter',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FPlatter.jpg?alt=media&token=bc05500b-b267-4ea0-b9cf-26760486fd94',
            linkUrl: 'shop/hats'
        },
        {
            id: 29,
            title: 'Time Out Gulshan',
            routeName: 'shop/time%20out%20gulshan', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FTime-Out.jpg?alt=media&token=aea99307-b8cb-494f-907f-10d159e0b386',
            linkUrl: 'shop/hats'
        },
        {
            id: 30,
            title: 'Dhaba Banani',
            routeName: 'shop/dhaba%20banani', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FDhaba.jpg?alt=media&token=bf48a4d2-3fb0-496d-8242-09a2f07b1b02',
            linkUrl: 'shop/hats'
        },
        {
            id: 31,
            title: 'Handi',
            routeName: 'shop/handi', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FHandi.jpg?alt=media&token=66b75601-f280-4275-9e24-15f5210f4bd3',
            linkUrl: 'shop/hats'
        },
        {
            id: 32,
            title: 'Shumis Hot Cake',
            routeName: 'shop/shumis%20hot%20cake', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FSumis-Hot-Cake.jpg?alt=media&token=8b189be6-db77-4de3-a8fe-e4d8f3957e31',
            linkUrl: 'shop/hats'
        },
        {
            id: 33,
            title: 'Sub Lovers',
            routeName: 'shop/sub%20lovers', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FSub-Lovers.jpg?alt=media&token=915679c9-051f-4eba-9003-4ab526e00dd1',
            linkUrl: 'shop/hats'
        },
        {
            id: 34,
            title: 'Dawat',
            routeName: 'shop/dawat', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/no-image-1.jpg?alt=media&token=94ff0fc7-3f48-4beb-b710-1640696fcbb1',
            linkUrl: 'shop/hats'
        },
        {
            id: 35,
            title: 'Cheong Shing Chinese Restaurant',
            routeName: 'shop/cheong%20shing%20chinese%20restaurant', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FCheong-Shing.png?alt=media&token=c4fde60f-0c43-42c7-8cfa-8ddf46d7a09d',
            linkUrl: 'shop/hats'
        },
        {
            id: 36,
            title: 'De Castle Restaurant',
            routeName: 'shop/de%20castle%20restaurant', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FDE-Castle.jpg?alt=media&token=854461c4-7993-40e3-b679-d6e09f37e430',
            linkUrl: 'shop/hats'
        },
        {
            id: 38,
            title: 'Aaheli Kabab & Restaurant',
            routeName: 'shop/aaheli%20kabab%20&%20restaurant', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FAaheli-Kebab.jpg?alt=media&token=7359088c-2e0c-4426-bba7-e3d374f58306',
            linkUrl: 'shop/hats'
        },
        {
            id: 39,
            title: 'Monster Foods',
            routeName: 'shop/monster%20foods', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FMonostar-Food.jpg?alt=media&token=57365100-389e-4aef-9e9c-d65708467068',
            linkUrl: 'shop/hats'
        },
        {
            id: 40,
            title: 'Roll Xpress Cafe',
            routeName: 'shop/roll%20xpress%20cafe', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FRoll-Express.png?alt=media&token=2020b56c-0234-496e-915c-686c7ec4ecdc',
            linkUrl: 'shop/hats'
        },
        {
            id: 41,
            title: 'Bitter Sweet Cafe',
            routeName: 'shop/bitter%20sweet%20cafe', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FBitter-Sweet.jpg?alt=media&token=4488ed4d-8cbd-4ae5-8637-04de4a665147',
            linkUrl: 'shop/hats'
        },
        {
            id: 42,
            title: 'Absolute Thai',
            routeName: 'shop/absolute%20thai', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Fw552-5afab10662546.jpg?alt=media&token=dae62e18-d3f4-4817-8f6d-b8071e02500e',
            linkUrl: 'shop/hats'
        },
        {
            id: 43,
            title: 'Boomers Cafe',
            routeName: 'shop/boomers%20cafe', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Fboomers-cafe6.jpg?alt=media&token=56ab25e5-fab2-475d-9645-36ada45c7457',
            linkUrl: 'shop/hats'
        },
        {
            id: 44,
            title: 'Dominos Pizza',
            routeName: 'shop/dominos%20pizza', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FDominos_pizza_logo.svg_.jpg?alt=media&token=880a2a8c-a217-4085-ba72-9fcc95f69ff6',
            linkUrl: 'shop/hats'
        },
        {
            id: 45,
            title: 'Chaap Shamlao',
            routeName: 'shop/chaap%20shamlao', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/no-image-1.jpg?alt=media&token=94ff0fc7-3f48-4beb-b710-1640696fcbb1',
            linkUrl: 'shop/hats'
        },
        {
            id: 46,
            title: 'Caspian Persian & Peshawari Cuisine',
            routeName: 'shop/caspian%20persian%20&%20peshawari%20cuisine', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FCaspain.jpg?alt=media&token=304daa4b-48bb-460b-b2b3-c5e3ccf637bd',
            linkUrl: 'shop/hats'
        },
        {
            id: 47,
            title: 'Gloria Jeans',
            routeName: 'shop/gloria%20jeans',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FGloria-Jeans-Coffee.jpg?alt=media&token=9aed2685-aaf9-47cd-b963-d836d16f52ff',
            linkUrl: 'shop/hats'
        },
        {
            id: 48,
            title: 'Star Hotel & Restaurant',
            routeName: 'shop/star%20hotel%20&%20restaurant', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Fstar_01_2_1.jpg?alt=media&token=23292029-631d-4901-a21b-e3a8929f59d1',
            linkUrl: 'shop/hats'
        },
        {
            id: 49,
            title: 'Fish Chicken & Beef',
            routeName: 'shop/fish%20chicken%20&%20beef', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Ffish-finger.jpg?alt=media&token=37ce771e-783c-407d-b7fa-0eceb498d205',
            linkUrl: 'shop/hats'
        },
        {
            id: 50,
            title: 'Sultan s Dine',
            routeName: 'shop/sultan%20s%20dine', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FSultan-Dine.jpg?alt=media&token=a88dd9ae-accf-4ed6-bc4d-5e4222af46d3',
            linkUrl: 'shop/hats'
        },
        {
            id: 51,
            title: 'BFC',
            routeName: 'shop/bfc',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FBFC.jpg?alt=media&token=851cd156-70bc-4ef5-b3f1-3289eab3b09f',
            linkUrl: 'shop/hats'
        },
        {
            id: 52,
            title: 'Korai Gost',
            routeName: 'shop/korai%20gost',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FAPPLE-Sim-Supported-Smart-Watch-5afab10d99dba.jpg?alt=media&token=811b536d-f3ff-4895-a16c-771d0ba73f8d',
            linkUrl: 'shop/hats'
        },
        {
            id: 53,
            title: 'Baburchi Restaurant',
            routeName: 'shop/baburchi%20restaurant',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/no-image-1.jpg?alt=media&token=94ff0fc7-3f48-4beb-b710-1640696fcbb1',
            linkUrl: 'shop/hats'
        },
        {
            id: 54,
            title: 'Hazi Biryani',
            routeName: 'shop/hazi%20biryani',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FHazi-Biryani.jpg?alt=media&token=fc66c73f-51aa-4302-9baf-969a570744de',
            linkUrl: 'shop/hats'
        },
        {
            id: 55,
            title: 'Dhaba',
            routeName: 'shop/dhaba', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FDhaba.jpg?alt=media&token=c8c76f3b-682f-4b8c-9242-939bcb6c4b2b',
            linkUrl: 'shop/hats'
        },
        {
            id: 56,
            title: 'Chilis GZ',
            routeName: 'shop/chillis%20gz',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FAPPLE-Sim-Supported-Smart-Watch-5afab0ff21f38.jpg?alt=media&token=09cba62b-1d34-4492-b630-1d7ba40f9ded',
            linkUrl: 'shop/hats'
        },
        {
            id: 57,
            title: 'Cheers Restaurant',
            routeName: 'shop/cheers%20restaurant', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FCheers.jpg?alt=media&token=7b2d2f95-0cd2-451d-a742-7d6bf6e17030',
            linkUrl: 'shop/hats'
        },
        {
            id: 58,
            title: 'FFC',
            routeName: 'shop/ffc',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FFFC.jpg?alt=media&token=9c128a80-ee53-4074-ba36-ecfc78867069',
            linkUrl: 'shop/hats'
        },
        {
            id: 59,
            title: 'Olympia Palace Restaurant',
            routeName: 'shop/olympia%20palace%20restaurant', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FOlympia-Palace-iftar-Box.jpg?alt=media&token=dc11fb76-8b52-4a5c-821c-4789a4c67a79',
            linkUrl: 'shop/hats'
        },
        {
            id: 60,
            title: 'Grand Prince Thai & Chinese Restaurant',
            routeName: 'shop/grand%20prince%20thai%20&%20chinese%20restaurant',            
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Fw552-5afab10659251.png?alt=media&token=4de857b4-8c3e-4af8-a32b-8e5c4eef4bf6',
            linkUrl: 'shop/hats'
        },
        {
            id: 61,
            title: 'BAR B Q TONITE',
            routeName: 'shop/bar%20b%20q%20tonite', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FBAR-B-Q-TONITE.jpg?alt=media&token=293e7e1a-1599-429d-8726-fb902e19abd4',
            linkUrl: 'shop/hats'
        },
        {
            id: 62,
            title: 'Red Tomato',
            routeName: 'shop/red%20tomato', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FRed-Tomato.png?alt=media&token=ee7c69b9-b4bd-4720-b0b8-99b7e99bef7e',
            linkUrl: 'shop/hats'
        },
        {
            id: 63,
            title: 'Golden Spoon',
            routeName: 'shop/golden%20spoon',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FGolden-Spoon.jpg?alt=media&token=638019f4-ebd9-4fa3-bcb0-6c45094ce142',
            linkUrl: 'shop/hats'
        },
        {
            id: 64,
            title: 'Broccoli Restaurant',
            routeName: 'shop/broccoli%20restaurant', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2FBroccoli-Restaurant.jpg?alt=media&token=fdaf7c4e-fbf1-4650-ad03-746bfd8ed643',
            linkUrl: 'shop/hats'
        },
        {
            id: 65,
            title: 'Shawarma King',
            routeName: 'shop/shawarmak%20ing',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FSharma-King.jpg?alt=media&token=9e1c5c87-a70e-4d6f-9a36-438a692f7b61',
            linkUrl: 'shop/hats'
        },
        {
            id: 66,
            title: 'Mr Burger',
            routeName: 'shop/mr%20burger', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FMr-Burger.jpg?alt=media&token=d55919a6-7d28-4679-af63-36e71e7ea2f5',
            linkUrl: 'shop/hats'
        },
        {
            id: 67,
            title: 'China Park',
            routeName: 'shop/china%20park', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FChina-Park.png?alt=media&token=445775f0-e788-4169-bdc1-41fef9baeee2',
            linkUrl: 'shop/hats'
        },
        {
            id: 68,
            title: 'Cafe Appeliano',
            routeName: 'shop/cafe%20appeliano', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FCaf%C3%A9-Appeliano.jpg?alt=media&token=c4dcda04-9f2c-4d78-93ab-e6fcf0d8b340',
            linkUrl: 'shop/hats'
        },
        {
            id: 69,
            title: 'Al Fresco',
            routeName: 'shop/al%20fresco', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FAi-Fresco.jpg?alt=media&token=9181e5f4-c15a-4a9f-b8e4-c64d052ab916',
            linkUrl: 'shop/hats'
        },
        {
            id: 70,
            title: 'Cafe Cherry Drops',
            routeName: 'shop/cafe%20cherry%20drops', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FCafe-Cherry-Drops.jpg?alt=media&token=5ecf1050-8f7b-4329-b5cc-0879097f2155',
            linkUrl: 'shop/hats'
        },
        {
            id: 71,
            title: 'Al Kaderia Restaurant',
            routeName: 'shop/al%20kaderia%20restaurant', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FAl-Kaderia.png?alt=media&token=8c79ae5c-4ffd-4806-ac19-653a8c5c52a8',
            linkUrl: 'shop/hats'
        },
        {
            id: 72,
            title: 'Bhojon Bari',
            routeName: 'shop/bhojon%20bari',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FBhojon-Bari.jpg?alt=media&token=062b0b33-a90c-4b50-ac3e-f7f971026f21',
            linkUrl: 'shop/hats'
        },
        {
            id: 73,
            title: 'Helvetia',
            routeName: 'shop/helvetia', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FHelvetia.jpg?alt=media&token=c9cef845-6d73-46a3-b3a5-7a186f36ce3f',
            linkUrl: 'shop/hats'
        },
        {
            id: 74,
            title: 'Tune & Bite Music Cafe',
            routeName: 'shop/tune%20&%20bite%20music%20caf', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FTune-Bite-Music-Cafe.png?alt=media&token=892b7741-955b-4ee3-b455-708fa8dea136',
            linkUrl: 'shop/hats'
        },
        {
            id: 75,
            title: 'Thirty3',
            routeName: 'shop/thirty3', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FThirty3.jpg?alt=media&token=63631117-a852-4f18-a808-de56eb595bb5',
            linkUrl: 'shop/hats'
        },,
        {
            id: 76,
            title: 'Swiss Bakery',
            routeName: 'shop/swiss%20bakery',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FSwiss-Bakery.jpg?alt=media&token=a5efe859-a9fb-4a47-b8b5-21c70e8681e5',
            linkUrl: 'shop/hats'
        },
        {
            id: 77,
            title: 'Fastway',
            routeName: 'shop/fastway',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FFastway.jpg?alt=media&token=b7a1a690-0887-4d82-a395-9e02dbb4774e',
            linkUrl: 'shop/hats'
        },
        {
            id: 78,
            title: 'Red Court',
            routeName: 'shop/red%20court', 
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2Flast%2FRed-Court.jpg?alt=media&token=c44234d0-2d53-4318-b639-0e0667faad9c',
            linkUrl: 'shop/hats'
        },
        {
            id: 79,
            title: 'Rice & Noodle',
            routeName: 'shop/rice%20&%20noodle',
            imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dhakafood-6fa13.appspot.com/o/RESTAURANTS%2FRess%2Frestaur%2FRice-Noodles.png?alt=media&token=83257816-3cb9-4300-82ad-4b3f24848de6',
            linkUrl: 'shop/hats'
        }        
    ]
       return (
            <div className="shop-page">
                <Route 
                exact 
                path={`${match.path}`} 
                component={CollectionsOverviewContainer}
                />
                <Route 
                exact
                path={`${match.path}/:collectionId`}
                component={CollectionsPageContainer}
                 />
                 <Route 
                exact
                path={`${match.path}/restaurants/r`}
                render={(props)=> <Directory sections={sections} {...props}/>}
                 />
                 <Route 
                exact
                path={`shop/kfc`}
                component={CollectionsPageContainer}
                 />
            </div>

        );
    }
const mapDispatachToProps = dispatch => ({
    fetchCollectionsStart: () => dispatch(fetchCollectionsStart())
})
export default connect(null,mapDispatachToProps)(ShopPage);